import React from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useDocumentsContext, useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

export const SelectedItemsCount: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const intl = useInternationalization();
  const { selectedDocuments } = useDocumentsContext();

  const selectedCount = selectedDocuments.length;

  if (selectedCount === 0) {
    return null;
  }

  const selectedItemsLabelKey =
    selectedCount === 1 ? 'custom.toolbar.selectedItem' : 'custom.toolbar.selectedItems';

  return (
    <div className="selectedItemsCount">
      {intl.formatNumber(selectedCount, '0')} {translate(selectedItemsLabelKey)}
    </div>
  );
};
